import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { VerificationActions } from "./VerificationActions";
import { StatusBadge } from "./StatusBadge";
import { formatDate } from "../../lib/dateUtils";

const STATUS_FILTERS = [
  { value: "pending", label: "Pending" },
  { value: "needs_info", label: "Needs Info" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "suspended", label: "Suspended" },
  { value: "all", label: "All" },
];

export const VerificationsTab = () => {
  const [list, setList] = useState(null);
  const [status, setStatus] = useState("pending");

  const load = () => {
    api.get("/admin/verifications", { params: { status } }).then(({ data }) => setList(data));
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  return (
    <div data-testid="verifications-tab">
      <div className="flex flex-wrap gap-3 mb-6">
        {STATUS_FILTERS.map((f) => (
          <button
            key={f.value}
            data-testid={`verification-status-filter-${f.value}`}
            onClick={() => setStatus(f.value)}
            className={`text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full border-2 transition-colors ${status === f.value ? "bg-stranger-orange text-clean-white border-stranger-orange" : "border-soft-gray text-midnight-black/70"}`}
          >
            {f.label}
          </button>
        ))}
      </div>

      {list === null ? (
        <p className="font-medium text-midnight-black/60">Loading...</p>
      ) : list.length === 0 ? (
        <p className="font-medium text-midnight-black/60" data-testid="no-verifications">Nothing here right now.</p>
      ) : (
        <div className="space-y-4">
          {list.map((p) => (
            <div key={p.id} className="border border-soft-gray rounded-2xl p-6" data-testid={`verification-request-${p.id}`}>
              <div className="flex items-start justify-between flex-wrap gap-4 mb-4">
                <div>
                  <p className="font-extrabold uppercase text-sm flex items-center gap-2">
                    {p.first_name} {p.last_name} — {p.business_name || p.verification?.business_name}
                    <StatusBadge status={p.verification_status} />
                  </p>
                  <p className="text-sm font-medium text-midnight-black/60">{p.email}</p>
                  <p className="text-sm font-medium text-midnight-black/60">{p.verification?.service_location}</p>
                  {p.verification?.phone && <p className="text-sm font-medium text-midnight-black/60">{p.verification.phone}</p>}
                  {p.verification?.website && <p className="text-sm font-medium text-midnight-black/60">{p.verification.website}</p>}
                  {p.verification?.instagram && <p className="text-sm font-medium text-midnight-black/60">IG: {p.verification.instagram}</p>}
                  {p.verification?.portfolio_note && <p className="text-sm font-medium text-midnight-black/60 mt-1">{p.verification.portfolio_note}</p>}
                  <p className="text-xs font-bold uppercase tracking-wide text-midnight-black/40 mt-2">Submitted {p.verification?.submitted_at ? formatDate(p.verification.submitted_at) : "—"}</p>
                  {p.rejection_reason && <p className="text-sm font-bold text-red-600 mt-2">Rejection reason: {p.rejection_reason}</p>}
                  {p.info_requested_message && <p className="text-sm font-bold text-stranger-orange mt-2">Info requested: {p.info_requested_message}</p>}
                  {p.suspended_reason && <p className="text-sm font-bold text-red-600 mt-2">Suspended: {p.suspended_reason}</p>}
                </div>
              </div>
              <VerificationActions photographerId={p.id} onDone={load} compact />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
